import { css, cx } from "../../../styled-system/css";
import { t } from "../../libs/i18n";

type Props = {
  checked: boolean;
  onChange: (next: boolean) => void;
};

const labelCss = css({
  fontSize: "14px",
  lineHeight: "1.4",
  color: "text.secondary",
});

const trackCss = css({
  position: "relative",
  w: "34px",
  h: "20px",
  rounded: "full",
  transition: "background-color 0.2s",
  flexShrink: 0,
});

const trackOnCss = css({ bg: "surface.accentPrimary" });
const trackOffCss = css({ bg: "surface.disable" });

const knobCss = css({
  position: "absolute",
  top: "2px",
  left: "2px",
  w: "16px",
  h: "16px",
  rounded: "full",
  bg: "surface.primary",
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2)",
  transition: "transform 0.2s",
});

export function InfoDisplayToggle({ checked, onChange }: Props) {
  return (
    <div
      className={css({
        display: "flex",
        alignItems: "center",
        gap: "8px",
        flexShrink: 0,
      })}
    >
      <span className={labelCss}>{t("情報表示")}</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={t("情報表示")}
        onClick={() => onChange(!checked)}
        className={cx(trackCss, checked ? trackOnCss : trackOffCss)}
      >
        <span
          className={knobCss}
          style={{ transform: checked ? "translateX(14px)" : "translateX(0)" }}
        />
      </button>
    </div>
  );
}
